<div class="mybets-scoreboard_players">
    <div class="bet-event-details">
        <div class="cell">{{ vm.eventName }}: {{ vm.leagueName }}</div>
        <div class="cell"><ms-my-bets-scoreboard-time [vm]="vm.getEventTimeViewModel()"></ms-my-bets-scoreboard-time></div>
    </div>
    <div class="player-info">
        @for (player of vm.players; track player) {
            <div>{{ $index + 1 }}. {{ player }}</div>
        }
    </div>
</div>
